import styled from 'styled-components';
import { Button } from './Button/Button';

const State = styled.div`
  padding: 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.surface};
  color: ${({ theme }) => theme.color.textMuted};
  font-size: ${({ theme }) => theme.fontSize.sm};
  p {
    margin: 0 0 10px;
  }
`;
const Skeleton = styled.div`
  display: grid;
  gap: 12px;
  padding: 12px 0;
  > span {
    height: 12px;
    border-radius: 4px;
    background: ${({ theme }) => theme.color.hover};
  }
  > span:first-child {
    width: 45%;
    height: 22px;
  }
  > span:last-child {
    width: 70%;
  }
`;
export interface LoadStateProps {
  loading?: boolean;
  error?: boolean;
  retry?: () => void;
  label: string;
  cards?: number;
}
export function LoadState({ loading, error, retry, label, cards = 1 }: LoadStateProps) {
  if (error)
    return (
      <State role="alert">
        <p>Couldn’t load {label}.</p>
        <Button onClick={retry} aria-label={`Retry ${label}`}>
          Retry
        </Button>
      </State>
    );
  if (!loading) return null;
  return (
    <State role="status" aria-label={`Loading ${label}`} aria-busy="true">
      {Array.from({ length: cards }, (_, i) => (
        <Skeleton key={i} aria-hidden="true">
          <span />
          <span />
          <span />
        </Skeleton>
      ))}
    </State>
  );
}
